module.exports = __webpack_public_path__ + "img/dajing.490de721.png";